module.exports = __webpack_public_path__ + "static/image3-98006b05db222d6ee39718154cdf35d0.png";